export class SqlInstructions {
    'clusterSqlScript';
    'perDatabaseSqlScript';
    'setupScript';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterSqlScript",
            "baseName": "clusterSqlScript",
            "type": "string",
            "format": ""
        },
        {
            "name": "perDatabaseSqlScript",
            "baseName": "perDatabaseSqlScript",
            "type": "string",
            "format": ""
        },
        {
            "name": "setupScript",
            "baseName": "setupScript",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlInstructions.attributeTypeMap;
    }
    constructor() {
    }
}
